import { Address } from '@yandex-int/k-common/typings';

import * as constants from './constants';

export const getLocalities = (phrase: string) => <const>{ type: constants.GET_LOCALITIES_REQUEST, phrase };

export const getLocalitiesSuccess = (localities: Array<Address>) =>
    <const>{ type: constants.GET_LOCALITIES_SUCCESS, localities };

export const getLocalitiesError = (error: Error) => <const>{ type: constants.GET_LOCALITIES_ERROR, error };

export const setCertificateSectionRequest = (certificateSlug: string) =>
    <const>{ type: constants.SET_CERTIFICATES_SECTION_REQUEST, certificateSlug };

export const setCertificateSectionSuccess = () => <const>{ type: constants.SET_CERTIFICATES_SECTION_SUCCESS };

export const setCertificateSectionError = () => <const>{ type: constants.SET_CERTIFICATES_SECTION_ERROR };

export const acceptSuggestion = (
    certificateSlug: string,
    generateImmediately: boolean,
    data: {
        email: string;
        locality?: string;
        school: string;
        full_name?: string;
        last_name?: string;
        first_name?: string;
        middle_name?: string;
    }
) => <const>{ type: constants.ACCEPT_SUGGESTION_REQUEST, certificateSlug, generateImmediately, data };

export const acceptSuggestionSuccess = (certificateSlug: string) =>
    <const>{ type: constants.ACCEPT_SUGGESTION_SUCCESS, certificateSlug };

export const acceptSuggestionError = (error: Error) => <const>{ type: constants.ACCEPT_SUGGESTION_ERROR, error };

export const closeSuggestion = (certificateSlug: string) =>
    <const>{ type: constants.CLOSE_SUGGESTION, certificateSlug };

export const cancelSuggestion = (certificateSlug: string) =>
    <const>{ type: constants.CANCEL_SUGGESTION, certificateSlug };
